import { defineAction } from '~/prix'
import { z } from 'zod'
import materialInventoryFetchAction from './materialInventoryFetch.action.json' with { type: 'json' }
import { materialInventoryObject } from '../materialInventoryObject'
import { materialObject } from '~/packages/rural/material/materialObject'

const materialInventoryFetchDefinition = defineAction({
  ...materialInventoryFetchAction,

  input: materialInventoryObject.pick({ id: true }),
  output: materialInventoryObject.extend({
    material: materialObject,
  }),
})

export default materialInventoryFetchDefinition
